import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import type { SectionName } from '../AutomatedCheckModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: 30
  },
  sectionItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    fontSize: 13
  },
  sectionText: {
    whiteSpace: 'pre'
  },
  divider: {
    width: '100%',
    height: 1,
    background: 'gainsboro'
  }
}));

type Props = {
  selected: SectionName;
};

function Progress(props: Props) {
  const classes = useStyles();

  const sections: SectionName[] = [
    'info',
    'application',
    'reference',
    'interview',
    'id',
    'dbs',
    'result'
  ];

  const selectedIndex = sections.indexOf(props.selected);

  const items = [
    {
      text: 'Application',
      icon: faCircle,
      showAfterIndex: 1
    },
    {
      text: 'References',
      icon: faCircle,
      showAfterIndex: 2
    },
    {
      text: 'Interview',
      icon: faCircle,
      showAfterIndex: 3
    },
    {
      text: 'ID & DBS',
      icon: faCircle,
      showAfterIndex: 4
    }
  ];
  return (
    <div className={classes.container}>
      {items.map((item, index) => (
        <>
          <div className={classes.sectionItem}>
            <FontAwesomeIcon
              icon={
                selectedIndex >= item.showAfterIndex ? faCircleCheck : faCircle
              }
              color={
                selectedIndex > item.showAfterIndex ? '#17BC25' : '#ABADB5'
              }
            />
            <div className={classes.sectionText}>{item.text}</div>
          </div>
          {index < 3 && <div className={classes.divider} />}
        </>
      ))}
    </div>
  );
}

export default Progress;
